import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { FamilyErrorDialogProps } from './FamilyErrorDialog.types';

export const openFamilyErrorModal = ({ onClose, ...data }: FamilyErrorDialogProps) =>
    openPopupHelper({ popupName: popupNames.FAMILY_ERROR, data, onClose });
